import { useEffect, useState } from 'react'
import Slider from 'react-slick'
import './homepage-collections.sass'
import API from '../../api'

export default function HomepageCollections() {
  const [collections, setCollections] = useState([])
  useEffect(function() {
    API('home/collections/')
      .get()
      .then(function(data) {
        setCollections(data.results)
      })
  }, [])

  const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    responsive: [
      { breakpoint: 1025, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      {
        breakpoint: 769,
        settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false },
      },
      {
        breakpoint: 481,
        settings: { slidesToShow: 2.3, slidesToScroll: 1, arrows: false },
      },
    ],
  }

  return (
    <div className='homepage-collections'>
      <Slider className='slick-pt-custom same-height' {...settings}>
        {collections.map((collection) => {
          return (
            <a
              className='homepage-collections__item'
              key={collection.url}
              href={collection.url}
            >
              <img
                className='homepage-collections__item__image'
                src={collection.mainImage}
              />
              <p className='homepage-collections__item__title'>
                {collection.title}
              </p>
              <span className='homepage-collections__item__overlay' />
            </a>
          )
        })}
      </Slider>
    </div>
  )
}
